import { ref } from "vue";
import { useIntersectionObserver } from "@vueuse/core";
import { useRoute } from "nuxt/app";
import { EAction, EVariables, pushToDataLayer } from "../utils/dataLayer.js";
export function useVisibilityTracking(element, componentCategory, componentName) {
  const wasTracked = ref(false);
  const route = useRoute();
  const { stop } = useIntersectionObserver(
    element,
    ([entry]) => {
      if (entry.intersectionRatio >= 0.5 && !wasTracked.value) {
        pushToDataLayer({
          [EVariables.EVENT]: "GAevent",
          [EVariables.CATEGORY]: `lp-${route.path}`,
          [EVariables.ACTION]: EAction.VISIBLE,
          [EVariables.LABEL]: componentName,
          [EVariables.COMPONENT_CATEGORY]: componentCategory,
          [EVariables.COMPONENT_NAME]: componentName
        });
        wasTracked.value = true;
        stop();
      }
    },
    { threshold: 0.5 }
  );
}
export function useClickTracking(params) {
  const route = useRoute();
  const queryParams = new URLSearchParams(route.query).toString();
  const queryString = queryParams ? `?${queryParams}` : "";
  const clickPath = new URL(params.clickPath, window.location.origin);
  pushToDataLayer({
    [EVariables.EVENT]: "GAevent",
    [EVariables.CATEGORY]: `lp-${route.path}`,
    [EVariables.ACTION]: EAction.CLICK,
    [EVariables.LABEL]: params.label,
    [EVariables.COMPONENT_CATEGORY]: params.componentCategory,
    [EVariables.COMPONENT_NAME]: params.componentName,
    [EVariables.CLICK_TEXT]: params.alt || params.label,
    [EVariables.CLICK_PATH]: clickPath.pathname || "",
    [EVariables.CLICK_PATH_PARAMS]: queryString,
    [EVariables.CLICK_ELEMENT]: params.clickElement
  });
}
